<template lang="html">
    <div class="editApp-container">
      <div class="breadCrumb-container">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>{{$t('message.merchant')}}</el-breadcrumb-item>
          <el-breadcrumb-item>{{$t('message.groupManage')}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="editApp-body-container verifone-panel">
        <div style="width: 100%">
          <!-- 组名 -->
          <el-row type="flex" align="middle">
            <el-col :span="3">
              <div style="padding-left: 15px">
                <span class="redStar">*</span>{{$t('message.groupName')}}
              </div>
            </el-col>
            <el-col :span="10">
              <el-input class="input-margin" v-model="groupName" />
            </el-col>
          </el-row>

          <!-- 新增设备按钮 -->
          <div style="margin-bottom: 10px">
            <el-row type="flex" align="middle">
              <!--数据统计 -->
              <el-col :span="5" :offset="1">
                <div class="total-font" >{{$t('message.totalOf')}}&nbsp;&nbsp;<span>{{tableData.length}}</span> {{$t('message.terminalCountLabelTail')}}</div>
              </el-col>
              <!-- 终端新增按钮 -->
              <el-col :span="3" :offset="14">
                <el-button class="verifone-btn" style="width: 145px" type="primary" plain icon="el-icon-plus" @click="showTerminalSelector()">
                  {{$t('message.addTerminals')}}
                </el-button>
              </el-col>
            </el-row>
          </div>

          <div class="groupTerminal-table-main btn-table">
            <el-table class="group-terminal-table" :data="tableData" max-height="350" height="350" stripe border @selection-change="selectionChange">
              <!-- 复选框 -->
              <el-table-column type="selection" width="40" align="center"/>

              <!-- SN -->
              <el-table-column prop="sn" :label="$t('message.sn')" width="170"/>

              <!-- 型号 -->
              <el-table-column prop="model" :label="$t('message.model')"  width="160"/>

              <!-- 设备ID -->
              <el-table-column prop="deviceId" :label="$t('message.deviceId')" width="160"/>

              <!-- 商户 -->
              <el-table-column prop="merchantName" :label="$t('message.merchant')" />
            </el-table>
          </div>

          <!-- 底部按钮 -->
          <div style="margin-top: 10px">
            <el-row :gutter="100" type="flex" align="middle">
              <el-col :span="2" :offset="1">
                <el-button class="verifone-btn" type="danger"  icon="el-icon-close" @click="delSelect()" plain>{{$t('message.delete')}}</el-button>
              </el-col>
              <el-col :span="6">
                <div class="total-font"><span>{{selectTerminals.length}}</span> {{$t('message.terminalChoosed')}}</div>
              </el-col>
              <el-col :span="2" :offset="8">
                <el-button class="verifone-btn" type="primary" icon="el-icon-close" @click="backToGroup" plain >{{$t('message.cancel')}}</el-button>
              </el-col>
              <el-col :span="2">
                <el-button class="verifone-btn" type="primary" icon="el-icon-document" @click="editSubmit" >{{$t('message.submit')}}</el-button>
              </el-col>
            </el-row>
          </div>
        </div>

        <group-terminal-selector :dialogVisible="groupTerminalSelectorVisible"
            @close="closeTerminalSelector" @emitTerminal="addTerminals"/>
      </div>
    </div>
</template>

<script >
import ElButton from "element-ui/packages/button/src/button";
import groupTerminalSelector from "./GroupTerminalSelector.vue";

export default {
    components: {ElButton,groupTerminalSelector},
    data () {
      return  {
          groupId: null,
          groupName: null,
          groupTerminalSelectorVisible: false, // 是否打开终端选择框

          /*--------------------------- 表格信息 start -------------------------------*/
          tableData: [],
          selectTerminals:[], //选中的信息
          /*--------------------------- 表格信息 start -------------------------------*/

          /*--------------------------------------------- 提示信息 start ---------------------------------------------*/
          no: this.$t('message.no'),
          yes: this.$t('message.yes'),
          warning: this.$t('message.warning'),
          modifySuccess: this.$t('message.modifySuccess'),
          noTickTerminal: this.$t('message.noTickTerminal')
          /*--------------------------------------------- 提示信息 end -----------------------------------------------*/
      }
    },
    mounted() {
      this.init();
      this.searchTerminal();
    },
    methods:{
      // 初始化数据
      init() {
        this.groupId = this.$route.params.groupId;
        this.groupName = this.$route.params.groupName;
      },

      // 终端查询
      searchTerminal(){
        let obj = {
          groupId: this.groupId
        };

        this.$axios({
            method: 'post',
            url: '/marketplace/groupTerminal/all',
            headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')},
            data: obj
        }).then(response => {
          if (response.data.code != '00') {
            this.$message({
                type: "error",
                message: response.data.desc,
                duration:'3000',
            });
            return;
          }else {
            this.tableData = response.data.data;
          }
        }).catch((err) => {
            console.log(err);
        });
      },

      // 返回
      backToGroup() {
        this.$router.replace('/grouplist');
      },

      // 打开终端选择器
      showTerminalSelector(){
        this.groupTerminalSelectorVisible = true;
      },

      // 关闭终端选择器
      closeTerminalSelector(){
        this.groupTerminalSelectorVisible = false;
      },

      // 接收用户选择的终端，并追加在列表末尾
      addTerminals(terminals){
        // 空数组，直接追加
        let dataLength = this.tableData.length,
            _this = this;
        if (dataLength == 0) {
           this.tableData = terminals;
           return;
        }

        // 非空数据，过滤相同ID后追加
        terminals.forEach(function(terminal){
          let isExists = 0;

          for(let i=0, j=dataLength; i<j; i++){
            if(terminal.terminalId == _this.tableData[i].terminalId){
              isExists = 1;
              break;
            }
          }

          if(isExists == 0){
            _this.tableData.push(terminal)
          }
        })
      },

      // 删除选中项
      delSelect(){
        let _this = this;

        // 未勾选提示
        if(this.selectTerminals.length == 0){
          _this.$message({
            type: "info",
            message: _this.$t('message.pleaseTick'),
            duration:'3000',
          });
          return;
        }

        // 进行删除操作
        _this.selectTerminals.forEach(function(terminal){
          _this.tableData.forEach(function (data,index) {
            if (terminal.terminalId == data.terminalId){
              _this.tableData.splice(index,1);
            }
          })
        });
      },

      // 提交编辑
      editSubmit(){
        let obj = {
          groupId: this.groupId,
          groupTerminals: this.tableData,
          groupName: this.groupName,
        }

        this.$axios({
            method: 'post',
            url: '/marketplace/group/edit',
            headers: {'Accept-Language': sessionStorage.getItem('acceptLanguage')},
            data: obj
        }).then(response => {
          if (response.data.code != '00') {
            this.$message({
                type: "error",
                message: response.data.desc,
                duration:'3000',
            });
            return;
          }else {
            this.$message({
                type: "success",
                message: this.modifySuccess,
                duration:'3000',
            });
            this.backToGroup();
          }
        }).catch((err) => {
            console.log(err);
        });

      },

      selectionChange(rows){
        this.selectTerminals = rows;
      },
    },
}

</script>

<style scoped lang="css">

.editApp-container {
    display: flex;
    display: -webkit-flex;
    align-items: center;
    width: 100%;
    font-family: 'Arial';
    padding: 0 0 10px 0;
}
.editApp-body-container {
    width:100%;
}
.redStar {
    color: red;
    font-size: 20px;
    font-weight: bold;
    margin-top: 5px;
    margin-right: 10px;
}

.input-margin {
    margin-right: 20px;
    width: 488px!important;
}

.edit-group-item :first-child{
    margin-top: 30px;
}

.groupTerminal-table-main {
  width: 95%;
  margin: 0 auto;
  background-color: #fff;
}

.total-font {
  color: #4eb4dd;
}
</style>



// WEBPACK FOOTER //
// src/components/page/group/GroupEdit.vue